import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'highlightSearch',
  standalone: true,
})
export class HighlightSearchPipe implements PipeTransform {
  public transform(value: string, search: string | null): string {
    if (!search) {
      return value
    }

    const pattern = search
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      .split(' ')
      .filter((t) => {
        return t.length > 0
      })
      .join('|')

    const regex = new RegExp(pattern, 'gi')

    return value.replace(
      regex,
      (match) => `<span class="highlight">${match}</span>`
    )
  }
}
